import { CalendarSeries } from "@salaxy/core";

/** Helper component for calendar related user interfaces: Dates and Times formatting etc. */
export class CalendarHelper {

  /** Periods / date ranges plotted on the chart. */
  public calendarPeriods: CalendarSeries[];

  constructor(private $sce: angular.ISCEService) {}

  /**
   * Gets a HTML formatted version of the description.
   * @param description Description text to format
   */
   public formatDescription(description): any
   {
     if (!description) {
       return null;
     }
     const html = description.replace(/<(http[^>]*)>/g, (match: string, p1: string) => {
       if (p1.endsWith(".jpg") || p1.endsWith(".jpeg") || p1.endsWith(".png") || p1.endsWith(".gif"))
       {
         return `<a href="${p1}" title="${p1}" target="_blank"><img src="${p1}" alt="External image" style="max-width: 400px"></a>`;
       }
       return `<a href="${p1}" title="${p1}" target="_blank">LINK</a>`;
     });
     return this.$sce.getTrustedHtml(html);
   }

}